import * as React from 'react';

export const thFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_285)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_285'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_285)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V4H0V0ZM0 16H28V20H0V16Z'
                    fill='#A6122D'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 6.66667H28V13.3333H0V6.66667Z'
                    fill='#292549'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_285'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
